import { render, staticRenderFns } from "./matchAutoSeries.vue?vue&type=template&id=c269837c&scoped=true&"
import script from "./matchAutoSeries.vue?vue&type=script&lang=js&"
export * from "./matchAutoSeries.vue?vue&type=script&lang=js&"
import style0 from "./matchAutoSeries.vue?vue&type=style&index=0&id=c269837c&lang=less&scoped=true&"
import style1 from "./matchAutoSeries.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c269837c",
  null
  
)

component.options.__file = "matchAutoSeries.vue"
export default component.exports